import script from "./WallView.vue?vue&type=script&setup=true&lang=js"
export * from "./WallView.vue?vue&type=script&setup=true&lang=js"

import "./WallView.vue?vue&type=style&index=0&id=05c67a58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05c67a58"]])

export default __exports__